
(function() {
    'use strict';

	angular.module('app').filter('encodeUrl', function() {

	    return function(input) {
	        if(input) {
	            return window.encodeURIComponent(input); 
	        }
	        return "";
	    }
	});

}());